// 開発時のみ使用するため、無視する。
/* eslint-disable import/no-extraneous-dependencies */
import { setupWorker } from 'msw';
import handlers from './handlers';

const mockServiceWorker = setupWorker(...handlers);

export default mockServiceWorker;
